import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';
import { logDebug, ReconnectedEvent } from '@hpfc/fc-frontend-core';

/**
 * Wrapper around a set of controls.  This component will emit a FccdReconnectedEvent when it and it's child controls are loaded.
 * This notifies the system that they are ready to receive data.
 */
@Component({
  tag: 'fccd-load-watcher',
})
export class LoadWatcher {
  /**
   * The id for the element in this component.
   */
  @Prop() elementId!: string;

  /**
   * Event that fires requesting a refresh when added / readded to the dom.
   */
  @Event() fccdReconnectedEvent: EventEmitter<ReconnectedEvent>;

  componentDidLoad() {
    this.fccdReconnectedEvent.emit(new ReconnectedEvent(this.elementId));
    logDebug('componentDidLoad()', this.elementId);
  }

  render() {
    return <slot />;
  }
}
